import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import CooperationEventModel from '../../../model/cooperationEvent.model';
import CooperationModel from '../../../model/cooperation.model';
import {MatDialog} from '@angular/material/dialog';
import EventService from '../../../api/event/event.service';
import * as moment from 'moment';
import {MatSnackBar} from '@angular/material/snack-bar';
import {EventFormComponent, EventFormDialogModel} from './event-form/event-form.component';
import AudioHelper from '../../../helper/audio.helper';
import UpdateService from '../../../api/update.service';
import {Subscription} from 'rxjs';
import {first} from 'rxjs/operators';

@Component({
  selector: 'app-event',
  templateUrl: './event.component.html',
  styleUrls: ['./event.component.scss']
})
export class EventComponent implements OnInit, OnDestroy {
  @Input() event: CooperationEventModel;
  @Input() cooperation: CooperationModel;
  @Input() compact = false;

  @Output() deleted = new EventEmitter<CooperationEventModel>();

  public days: number;
  public diff: number;

  private changeSubscription: Subscription;

  constructor(private dialog: MatDialog, private eventService: EventService,
              private snackBar: MatSnackBar, private updateService: UpdateService) { }

  ngOnInit(): void {
    if(this.cooperation) {
      this.event.cooperation = this.cooperation;
    }
    if(this.event.deadline != null) {
      let milliDiff = moment(this.event.deadline).toDate().getTime() - Date.now();
      this.diff = milliDiff;

      milliDiff = moment(this.event.deadline).set('hour', 0).set('minute', 0).set('second', 0).set('millisecond', 0).toDate().getTime()
        - moment().set('hour', 0).set('minute', 0).set('second', 0).set('millisecond', 0).toDate().getTime();
      this.days = Math.round(milliDiff / 1000 / 60 / 60 / 24);
    }

    this.changeSubscription = this.updateService.subscribeToChanges<CooperationEventModel>('events').subscribe(change => {
      if(change && this.event.id == change.id) {
        Object.assign(this.event, change.payload);
      }
    });
  }

  ngOnDestroy() {
    this.changeSubscription.unsubscribe();
  }

  public checkboxClicked() {
    if (this.event.done) {
      this.eventService.undone(this.event).pipe(first()).subscribe(result => {
        if(result) {
          this.event.done = null;
        }
      });
    } else {
      this.eventService.done(this.event).pipe(first()).subscribe(result => {
        if(result) {
          const audio = new AudioHelper();
          audio.playSuccess();
          this.event.done = new Date();
        }
      });
    }
  }

  public showUpdateSnack() {
    this.dialog.closeAll();
    this.snackBar.open('Termin wurde aktualisiert');
  }

  public delete() {
    this.eventService.delete(this.event).pipe(first()).subscribe(result => {
      if(result) {
        this.deleted.emit(this.event);
      }
    });
  }

  public editEvent() {
    this.eventService.show(this.event.id, false).pipe(first()).subscribe(result => {
      const dialogData = new EventFormDialogModel(result);

      const dialogRef = this.dialog.open(EventFormComponent, {
        data: dialogData
      });

      dialogRef.afterClosed().pipe(first()).subscribe(dialogResult => {
        if(dialogResult) {
          Object.assign(this.event, dialogResult);
          this.snackBar.open('Termin wurde bearbeitet');
        }
      });
    });
  }

}
